
const $leadCaptureForm = $('#lead-capture-form'),
  $salesforceForm = $('#salesforce-lead-capture-form')

if ($leadCaptureForm.length && $salesforceForm.length) {
  const $recaptchaTokenInput = $leadCaptureForm.find('.js-recaptcha'),
    $emailField = $leadCaptureForm.find("#js-join-email"),
    $privacyCheckbox = $leadCaptureForm.find('#js-privacy'),
    $privacyErrorMessage = $leadCaptureForm.find('#js-privacy-error-message')

    $emailField.val('')
    $privacyCheckbox.prop('checked', false)
    $privacyErrorMessage.removeClass('show-error')

  grecaptcha.ready(function() {
    grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', { action: 'leadCapture' })
      .then(function(token) {
        $recaptchaTokenInput.val(token)
      })
  })
  $emailField.on('focus', () => {
    $privacyErrorMessage.removeClass('show-error')
  })
  $privacyCheckbox.on('click', ()=> {
    $privacyErrorMessage.removeClass('show-error')
    $privacyCheckbox.parent('.rn-label_radio').toggleClass('r_on')
  })
  // Client requested saving users details in Salesforce rather than saving user details in Silverstripe
  $leadCaptureForm.on('submit', function(e) {
    e.preventDefault()
    if ($privacyCheckbox.prop('checked')) {
      $salesforceForm.find('#js-salesforce-email').val($emailField.val())

      const data = $(this).serialize(),
        $submitButton = $(this).find('#lead-capture-form-button'),
        $stepOne = $(this).find('.f-lc__step-one'),
        $stepTwo = $(this).find('.f-lc__step-two'),
        $stepThree = $(this).find('.f-lc__step-three')
      $submitButton.prop('disabled', true)
      $.ajax({
        type: 'POST',
        url: 'leadCapture/verify_recaptcha',
        data,
        dataType: 'json'
      })
      .done(function(msg) {
        console.log('Reached verify_recaptcha done method for leadCapture. Score:', msg.score, ' Status:', msg.success)
        if (typeof(msg.success) != 'undefined' && msg.success == true) {
          console.log('Reached success condition.')
          $stepOne.show()
          $stepTwo.hide()
          $stepThree.hide()
          $salesforceForm.submit()
          // reset the form fields
          $emailField.val('')
          $privacyCheckbox.prop('checked', false)
          console.log( 'email value: ', $emailField.val(), 'privacy checked: ', $privacyCheckbox.prop('checked'))
        } else {
          console.log('Reached failed condition.')
          $stepOne.hide()
          $stepTwo.hide()
          $stepThree.show()
        }
      })
      .fail(function() {
        $stepOne.hide()
        $stepTwo.hide()
        $stepThree.show()
      })
      .always(function() {
        $submitButton.prop('disabled', false)
        grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', { action: 'leadCapture' })
          .then(function(token) {
            $recaptchaTokenInput.val(token)
          })
      })
    } else {
      $privacyErrorMessage.addClass('show-error')
    }
  })
}
